export type DeleteUserErrorCode = 'PERMISSION_DENIED' | 'UNKNOWN';

export class DeleteUserError extends Error {
    code: DeleteUserErrorCode;
    constructor(code: DeleteUserErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
